import React, {ComponentType, useState} from 'react'
import PageSpinnerAtom from '../../@atoms/to_layout/page_spinner/page_spinner.atom'

export interface WithLoaderProps {
  setLoading: (loading: boolean) => void
}

export default function withLoader<T>(
  Component: ComponentType<T & WithLoaderProps>,
) {
  const Hoc: React.FC<T> = function (props) {
    const [loading, setLoading] = useState(true)

    return (
      <>
        {loading && <PageSpinnerAtom />}
        <Component {...props} setLoading={setLoading} />
      </>
    )
  }
  return Hoc
}
